export default "__VITE_ASSET__CxHLbpq2__"